<template>
  <div id="app">
    <!-- 图片搜索的loading -->
    <loading v-if="loading"></loading>
    <router-view v-wechat-title="$route.meta.title" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import Loading from "./components/Loading";
export default {
  data() {
    return {};
  },
  components: {
    Loading,
  },
  computed: {
    ...mapState(["loading"]),
  },
  methods: {},
};
</script>
<style lang="scss">
@import "./css/base";

// @media screen and (max-width: 1160px) {
//   html {
//     font-size: 500% !important;
//   }
//   body {
//     width: 100% !important;
//   }
// }
// @media screen and (max-width: 1200px) {
//   html {
//     font-size: 700% !important;
//   }
//   body {
//     width: 1715px !important;
//   }
// }
html,
body,
#app {
  width: 100%;
  //   height: 100%;
}
#nprogress .bar {
  background: #f3c622 !important; //自定义颜色
}
</style>
 